import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Grid,
  Typography,
  Avatar,
  TextField,
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useMemo } from "react";
import "../Pages/voucher.css";

const GetApplications = ({ id }) => {
  // const { id } = useParams();

  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const token = sessionStorage.getItem("token");
  const [applicationData, setApplicationData] = useState(null);
  const [academics, setAcademics] = useState([]);
  const [tests, setTests] = useState([]);
  const [programData, setProgramData] = useState([]);
  const [vouchers, setVouchers] = useState([]);
  const [open, setOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState("");
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const [publications, setPublications] = useState([]);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await fetch(
          `${BASE_URL}/submit_application/get_application_admin/${id}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch application data");
        }

        const data = await response.json();
        setApplicationData(data.application);
        setPublications(data.publications || {});
        setAcademics(data.academics || []);
        setProgramData(data.program_data || []);
        setVouchers(data.vouchers || []);
        setTests(data.tests || []);
      } catch (error) {
        console.error("Error fetching application data:", error);
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchData();
    }
  }, [token, id]);

  if (!applicationData) {
    return <Typography>Loading...</Typography>;
  }

  const handleOpen = (image) => {
    setCurrentImage(image);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setCurrentImage("");
  };

  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
    setDialogOpen(true);
  };

  const handleClose2 = () => {
    setDialogOpen(false);
    setSelectedImage("");
  };

  // Helper function to create two-column layout
  const createTwoColumnLayout = (items) => {
    return items
      .filter(Boolean)
      .reduce((acc, item, index) => {
        if (index % 2 === 0) {
          acc.push([item, null]);
        } else {
          acc[acc.length - 1][1] = item;
        }
        return acc;
      }, [])
      .map(([item, nextItem], index) => (
        <Grid container spacing={2} key={index} justifyContent="flex-start">
          <Grid item xs={6}>
            <Box sx={{ display: "flex", marginBottom: 1 }}>
              <Typography
                variant="body1"
                sx={{
                  fontWeight: "bold",
                  width: 180,
                  marginRight: 4,
                  marginLeft: 4,
                }}
              >
                {item.label}:
              </Typography>
              <Typography variant="body1" sx={{ flex: 1 }}>
                {item.value}
              </Typography>
            </Box>
          </Grid>
          {nextItem && (
            <Grid item xs={6}>
              <Box sx={{ display: "flex", marginBottom: 1 }}>
                <Typography
                  variant="body1"
                  sx={{
                    fontWeight: "bold",
                    width: 180,
                    marginRight: 4,
                    marginLeft: 4,
                  }}
                >
                  {nextItem.label}:
                </Typography>
                <Typography variant="body1" sx={{ flex: 1 }}>
                  {nextItem.value}
                </Typography>
              </Box>
            </Grid>
          )}
        </Grid>
      ));
  };

  return (
    <>
      <Box padding={3}>
        <Card>
          <CardContent>
            <Grid container spacing={4}>
              {/* Personal Information */}
              <Grid item xs={12}>
                <Typography className="title-text" align="center">
                  Personal Information
                </Typography>

                <Avatar
                  src={applicationData.applicant_image}
                  alt="Applicant Image"
                  sx={{
                    width: 140,
                    height: 140,
                    marginBottom: 2,
                    display: "block",
                    marginLeft: "auto",
                    marginRight: "auto",
                    boxShadow: 2,
                  }}
                />

                <Box>
                  {createTwoColumnLayout([
                    { label: "CNIC", value: applicationData.applicant_cnic },
                    { label: "Date of Birth", value: applicationData.dob },
                    { label: "Name", value: applicationData.name },
                    { label: "Email", value: applicationData.email },
                    {
                      label: "Father's Name",
                      value: applicationData.father_name,
                    },
                    {
                      label: "Father's Occupation",
                      value: applicationData.father_occupation,
                    },
                    applicationData.father_income && {
                      label: "Father's Income",
                      value: applicationData.father_income,
                    },
                    {
                      label: "Father's CNIC",
                      value: applicationData.father_cnic,
                    },
                    applicationData.bzu_registration && {
                      label: "BZU Registration",
                      value: applicationData.bzu_registration,
                    },
                    { label: "Gender", value: applicationData.gender },
                    {
                      label: "Nationality",
                      value: applicationData.nationality,
                    },
                    { label: "Province", value: applicationData.province },
                    { label: "Domicile", value: applicationData.domicile },
                    { label: "Religion", value: applicationData.religion },
                    {
                      label: "Current Address",
                      value: applicationData.current_address,
                    },
                    {
                      label: "Permanent Address",
                      value: applicationData.permanent_address,
                    },
                    applicationData.tel_no && {
                      label: "Telephone No",
                      value: applicationData.tel_no,
                    },
                    {
                      label: "Father's Phone",
                      value: applicationData.father_phone,
                    },
                    {
                      label: "Applicant's Phone",
                      value: applicationData.applicant_phone,
                    },
                    applicationData.place_of_stay && {
                      label: "Place of Stay",
                      value: applicationData.place_of_stay,
                    },
                    {
                      label: "Hafiz-e-Quran",
                      value:
                        applicationData.hafiz_quran === "True" ? "Yes" : "No",
                    },
                    {
                      label: "Disability",
                      value: applicationData.disability || "No",
                    },
                    applicationData.need_transport && {
                      label: "Need Transport",
                      value: applicationData.need_transport ? "Yes" : "No",
                    },
                    {
                      label: "Application Type",
                      value: applicationData.application_type,
                    },
                    { label: "Batch Name", value: applicationData.batch_name },
                    applicationData.instructor_name && {
                      label: "Instructor Name",
                      value: applicationData.instructor_name,
                    },
                    applicationData.proposal_title && {
                      label: "Proposal Title",
                      value: applicationData.proposal_title,
                    },
                  ])}
                </Box>
              </Grid>

              <Divider className="custom-style" />

              {/* Documents */}
              <Grid
                item
                xs={12}
                container
                direction="column"
                justifyContent="center"
                alignItems="center"
              >
                <Typography className="title-text" align="center" gutterBottom>
                  CNIC Documents
                </Typography>

                {/* Applicant CNIC */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: 4,
                    marginBottom: 3,
                  }}
                >
                  <Typography>Applicant CNIC</Typography>
                  {applicationData.applicant_cnic_front && (
                    <Box
                      sx={{
                        width: 265,
                        height: 120,
                        borderRadius: 2,
                        overflow: "hidden",
                        boxShadow: 2,
                        backgroundColor: "#f3f3f3",
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        handleOpen(applicationData.applicant_cnic_front)
                      }
                    >
                      <img
                        src={applicationData.applicant_cnic_front}
                        alt="CNIC Front"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    </Box>
                  )}
                  {applicationData.applicant_cnic_back && (
                    <Box
                      sx={{
                        width: 265,
                        height: 120,
                        borderRadius: 2,
                        overflow: "hidden",
                        boxShadow: 2,
                        backgroundColor: "#f3f3f3",
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        handleOpen(applicationData.applicant_cnic_back)
                      }
                    >
                      <img
                        src={applicationData.applicant_cnic_back}
                        alt="CNIC Back"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    </Box>
                  )}
                </Box>

                {/* Father CNIC */}
                {(applicationData.father_cnic_front ||
                  applicationData.father_cnic_back) && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: 4,
                      marginBottom: 3,
                    }}
                  >
                    <Typography>Father CNIC</Typography>
                    {applicationData.father_cnic_front && (
                      <Box
                        sx={{
                          width: 265,
                          height: 120,
                          borderRadius: 2,
                          overflow: "hidden",
                          boxShadow: 2,
                          backgroundColor: "#f3f3f3",
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          handleOpen(applicationData.father_cnic_front)
                        }
                      >
                        <img
                          src={applicationData.father_cnic_front}
                          alt="Father CNIC Front"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </Box>
                    )}
                    {applicationData.father_cnic_back && (
                      <Box
                        sx={{
                          width: 265,
                          height: 120,
                          borderRadius: 2,
                          overflow: "hidden",
                          boxShadow: 2,
                          backgroundColor: "#f3f3f3",
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          handleOpen(applicationData.father_cnic_back)
                        }
                      >
                        <img
                          src={applicationData.father_cnic_back}
                          alt="Father CNIC Back"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </Box>
                    )}
                  </Box>
                )}

                {/* Proposal Attachment */}
                {applicationData.proposal_attachment && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: 4,
                      marginBottom: 3,
                    }}
                  >
                    <Typography>Proposal Attachment</Typography>
                    <Box
                      sx={{
                        width: 265,
                        height: 120,
                        borderRadius: 2,
                        overflow: "hidden",
                        boxShadow: 2,
                        backgroundColor: "#f3f3f3",
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        handleOpen(applicationData.proposal_attachment)
                      }
                    >
                      <img
                        src={applicationData.proposal_attachment}
                        alt="Proposal Attachment"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    </Box>
                  </Box>
                )}

                {/* Modal for displaying the clicked image */}
                <Dialog open={open} onClose={handleClose} maxWidth="md">
                  <DialogTitle>
                    <IconButton
                      edge="end"
                      color="inherit"
                      onClick={handleClose}
                      aria-label="close"
                      sx={{
                        position: "absolute",
                        top: 8,
                        color: "gray",
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                  </DialogTitle>
                  <DialogContent>
                    <img
                      src={currentImage}
                      alt="Expanded view"
                      style={{
                        width: "100%",
                        height: "auto",
                        borderRadius: 8,
                      }}
                    />
                  </DialogContent>
                </Dialog>
              </Grid>

              <Divider className="custom-style" />

              {/* Emergency Contact */}
              <Grid item xs={12}>
                <Typography className="title-text" align="center">
                  Emergency Contact
                </Typography>
                <Box marginBottom={2}>
                  {createTwoColumnLayout([
                    {
                      label: "Name",
                      value: applicationData.emergency_contact_name,
                    },
                    {
                      label: "Phone",
                      value: applicationData.emergency_contact_no,
                    },
                    {
                      label: "Address",
                      value: applicationData.emergency_contact_address,
                    },
                  ])}
                </Box>
              </Grid>

              <Divider className="custom-style" />

              {/* ACADEMICS Info */}
              <Grid item xs={12}>
                <Typography className="title-text" align="center">
                  Academics
                </Typography>
                {academics.map((academic, index) => (
                  <Box key={index} marginBottom={3}>
                    <Typography
                      variant="h6"
                      sx={{ fontWeight: "bold", marginBottom: 2 }}
                    >
                      {academic.degree}
                    </Typography>
                    {createTwoColumnLayout([
                      { label: "Degree", value: academic.degree },
                      { label: "Board", value: academic.board },
                      academic.year && { label: "Year", value: academic.year },
                      { label: "Roll No", value: academic.roll_no },
                      {
                        label: "Marks",
                        value: `${academic.obtain_marks} / ${academic.total_marks}`,
                      },
                      academic.division && {
                        label: "Division",
                        value: academic.division,
                      },
                      academic.exam_pass_in && {
                        label: "Exam Pass in",
                        value: academic.exam_pass_in,
                      },
                      academic.grade && {
                        label: "Grade",
                        value: academic.grade,
                      },
                      academic.major_subject && {
                        label: "Major Subject",
                        value: academic.major_subject,
                      },
                      academic.position && {
                        label: "Position",
                        value: academic.position,
                      },
                      {
                        label: "Percentage",
                        value: `${Number(academic.percentage).toFixed(2)}%`,
                      },
                      academic.elective_subject_one && {
                        label: "Elective Subject 1",
                        value: academic.elective_subject_one,
                      },
                      academic.elective_subject_one && {
                        label: "Subject 1 Marks",
                        value: `${academic.elective_subject_one_obtain_marks} / ${academic.elective_subject_one_total_marks}`,
                      },
                      academic.elective_subject_two && {
                        label: "Elective Subject 2",
                        value: academic.elective_subject_two,
                      },
                      academic.elective_subject_two && {
                        label: "Subject 2 Marks",
                        value: `${academic.elective_subject_two_obtain_marks} / ${academic.elective_subject_two_total_marks}`,
                      },
                      academic.elective_subject_three && {
                        label: "Elective Subject 3",
                        value: academic.elective_subject_three,
                      },
                      academic.elective_subject_three && {
                        label: "Subject 3 Marks",
                        value: `${academic.elective_subject_three_obtain_marks} / ${academic.elective_subject_three_total_marks}`,
                      },
                      academic.is_result_awaitng && {
                        label: "Result Awaiting",
                        value: academic.is_result_awaitng ? "Yes" : "No",
                      },
                    ])}

                    {/* Display the result (PDF/Image) */}
                    {academic.result && (
                      <Box
                        mt={2}
                        sx={{
                          maxWidth: "100%",
                          overflow: "hidden",
                          textAlign: "center",
                        }}
                      >
                        {academic.result.endsWith(".pdf") ? (
                          <iframe
                            src={academic.result}
                            width="100%"
                            height="400px"
                            style={{
                              border: "none",
                              maxWidth: "60%",
                              maxHeight: "400px",
                            }}
                            title="Result PDF"
                          ></iframe>
                        ) : (
                          <img
                            src={academic.result}
                            alt="Result"
                            width="100%"
                            style={{
                              maxWidth: "60%",
                              height: "auto",
                              maxHeight: "400px",
                              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                              borderRadius: "12px",
                              objectFit: "contain",
                              transition:
                                "transform 0.3s ease, box-shadow 0.3s ease",
                              cursor: "pointer",
                            }}
                            onClick={() => handleImageClick(academic.result)}
                          />
                        )}
                      </Box>
                    )}
                  </Box>
                ))}

                {/* Dialog for Image */}
                <Dialog
                  open={dialogOpen}
                  onClose={handleClose2}
                  maxWidth="md"
                  fullWidth
                >
                  <DialogTitle>
                    <IconButton
                      edge="end"
                      color="inherit"
                      onClick={handleClose2}
                      aria-label="close"
                      sx={{
                        position: "absolute",
                        top: 8,
                        color: "gray",
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                  </DialogTitle>
                  <DialogContent>
                    <img
                      src={selectedImage}
                      alt="Enlarged Result"
                      style={{
                        width: "100%",
                        height: "auto",
                        borderRadius: "12px",
                        objectFit: "contain",
                      }}
                    />
                  </DialogContent>
                </Dialog>
              </Grid>

              <Divider className="custom-style" />

              {/* Test Details */}
              {tests && tests.length > 0 && (
                <Grid item xs={12}>
                  <Typography className="title-text" align="center">
                    Test Selections
                  </Typography>
                  {tests.map((test, index) => (
                    <Box key={index} marginBottom={2}>
                      {createTwoColumnLayout([
                        { label: "Test Type", value: test.type || "N/A" },
                        { label: "Roll No", value: test.roll_no || "N/A" },
                        {
                          label: "Obtained Marks",
                          value: test.obtain_marks || "N/A",
                        },
                        {
                          label: "Total Marks",
                          value: test.total_marks || "N/A",
                        },
                        { label: "Test Date", value: test.test_date || "N/A" },
                      ])}
                    </Box>
                  ))}
                </Grid>
              )}

              <Divider className="custom-style" />

              {/* Program Info */}
              <Grid
                item
                xs={12}
                container
                direction="column"
                justifyContent="center"
                alignItems="center"
              >
                <Typography className="title-text" align="center" gutterBottom>
                  Applied Programs
                </Typography>
                {loading ? (
                  <Typography align="center">Loading...</Typography>
                ) : programData.length > 0 ? (
                  <Grid container spacing={2} justifyContent="center">
                    <Grid item xs={10} md={10}>
                      {programData
                        .reduce((acc, program) => {
                          const existingProgram = acc.find(
                            (item) => item.program_name === program.program_name
                          );

                          if (existingProgram) {
                            existingProgram.quotas.push({
                              quota_name: program.quota_name,
                              program_group: program.program_group,
                            });
                          } else {
                            acc.push({
                              program_name: program.program_name,
                              quotas: [
                                {
                                  quota_name: program.quota_name,
                                  program_group: program.program_group,
                                },
                              ],
                            });
                          }
                          return acc;
                        }, [])
                        .map((program, index) => (
                          <Grid item xs={12} key={index}>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                marginBottom: 1,
                              }}
                            >
                              <Typography
                                variant="body1"
                                sx={{ fontWeight: "bold", textAlign: "center" }}
                              >
                                {index + 1}. {program.program_name}{" "}
                                {program.quotas.map((quota, i) => (
                                  <span key={i}>({quota.quota_name})</span>
                                ))}
                              </Typography>
                            </Box>
                          </Grid>
                        ))}
                    </Grid>
                  </Grid>
                ) : (
                  <Typography align="center">
                    No program choices available
                  </Typography>
                )}
              </Grid>
              {/* Research Proposal Details (only for PH.D / Phd-5) */}
              {(applicationData.application_type === "PH.D" ||
                applicationData.application_type === "Phd-5") &&
                (applicationData.instructor_name ||
                  applicationData.proposal_title ||
                  applicationData.proposal_attachment) && (
                  <>
                    <Divider className="custom-style" />
                    <Grid item xs={12}>
                      <Typography className="title-text" align="center">
                        Research Proposal Details
                      </Typography>
                      <Box marginBottom={2}>
                        {createTwoColumnLayout([
                          applicationData.instructor_name && {
                            label: "Supervisor",
                            value: applicationData.instructor_name,
                          },
                          applicationData.proposal_title && {
                            label: "Research Proposal Title",
                            value: applicationData.proposal_title,
                          },
                        ])}
                      </Box>

                      {/* Proposal Attachment */}
                      {applicationData.proposal_attachment && (
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: 4,
                            marginBottom: 3,
                          }}
                        >
                          <Typography>Research Proposal Attachment</Typography>
                          <Box
                            sx={{
                              width: 265,
                              height: 120,
                              borderRadius: 2,
                              overflow: "hidden",
                              boxShadow: 2,
                              backgroundColor: "#f3f3f3",
                              cursor: "pointer",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            {(() => {
                              const fileUrl =
                                applicationData.proposal_attachment;
                              const isImage =
                                /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(fileUrl);
                              const isPdf = /\.pdf$/i.test(fileUrl);

                              if (isImage) {
                                return (
                                  <a
                                    href={fileUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ width: "100%", height: "100%" }}
                                  >
                                    <img
                                      src={fileUrl}
                                      alt="Proposal Attachment"
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                      }}
                                    />
                                  </a>
                                );
                              } else if (isPdf) {
                                return (
                                  <a
                                    href={fileUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      textDecoration: "none",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    <Typography
                                      sx={{
                                        color: "primary.main",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      PDF File – Open in new tab
                                    </Typography>
                                  </a>
                                );
                              } else {
                                return (
                                  <a
                                    href={fileUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      textDecoration: "none",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    <Typography
                                      sx={{
                                        color: "error.main",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      Unsupported File – Open in new tab
                                    </Typography>
                                  </a>
                                );
                              }
                            })()}
                          </Box>
                        </Box>
                      )}
                    </Grid>
                  </>
                )}

              {/* Research Publications (only for PH.D / Phd-5) */}
              {(applicationData.application_type === "PH.D" ||
                applicationData.application_type === "Phd-5") &&
                publications &&
                publications.length > 0 && (
                  <>
                    <Divider className="custom-style" />
                    <Grid item xs={12}>
                      <Typography className="title-text" align="center">
                        Research Publications
                      </Typography>
                      {publications.map((pub, index) => (
                        <Box key={index} marginBottom={3}>
                          <Typography
                            variant="h6"
                            sx={{ fontWeight: "bold", marginBottom: 2 }}
                          >
                            Publication {index + 1}
                          </Typography>
                          {createTwoColumnLayout([
                            pub.title && {
                              label: "Publication Title",
                              value: pub.title,
                            },
                            pub.name_of_journal && {
                              label: "Journal Name",
                              value: pub.name_of_journal,
                            },
                            pub.year && {
                              label: "Publication Year",
                              value: pub.year,
                            },
                            pub.volume && {
                              label: "Volume",
                              value: pub.volume,
                            },
                            pub.issue && { label: "Issue", value: pub.issue },
                            pub.page_nos && {
                              label: "Page Numbers",
                              value: pub.page_nos,
                            },
                            {
                              label: "HEC Recognized",
                              value: pub.hec_recognized ? "Yes" : "No",
                            },
                          ])}
                        </Box>
                      ))}
                    </Grid>
                  </>
                )}

              <Divider className="custom-style" />

              {/* Voucher Information */}
              {vouchers && vouchers.length > 0 && (
                <Grid item xs={12}>
                  <Typography className="title-text" align="center">
                    Voucher Information
                  </Typography>
                  {vouchers.map((voucher, index) => (
                    <Box key={index} marginBottom={2}>
                      <Typography
                        variant="h6"
                        sx={{ fontWeight: "bold", marginBottom: 2 }}
                      >
                        Voucher {index + 1}
                      </Typography>
                      {createTwoColumnLayout([
                        {
                          label: "Voucher Code",
                          value: voucher.voucher_code || "N/A",
                        },
                        {
                          label: "Amount",
                          value: voucher.amount
                            ? `PKR ${voucher.amount}`
                            : "N/A",
                        },
                        {
                          label: "Is Paid",
                          value: voucher.is_paid ? "Yes" : "No",
                        },
                        {
                          label: "Due Date",
                          value: voucher.due_date
                            ? new Date(voucher.due_date).toLocaleDateString()
                            : "N/A",
                        },
                        voucher.payment_date && {
                          label: "Payment Date",
                          value: new Date(
                            voucher.payment_date
                          ).toLocaleDateString(),
                        },
                        voucher.payment_mode && {
                          label: "Payment Mode",
                          value: voucher.payment_mode,
                        },
                        voucher.transaction_id && {
                          label: "Transaction ID",
                          value: voucher.transaction_id,
                        },
                        voucher.tution_fee && {
                          label: "Tuition Fee",
                          value: `PKR ${voucher.tution_fee}`,
                        },
                        voucher.registration_fee && {
                          label: "Registration Fee",
                          value: `PKR ${voucher.registration_fee}`,
                        },
                        voucher.medical_fee && {
                          label: "Medical Fee",
                          value: `PKR ${voucher.medical_fee}`,
                        },
                        voucher.admin_charges && {
                          label: "Admin Charges",
                          value: `PKR ${voucher.admin_charges}`,
                        },
                      ])}
                    </Box>
                  ))}
                </Grid>
              )}
            </Grid>
          </CardContent>
        </Card>
      </Box>
    </>
  );
};

export default GetApplications;
